import {
  getFieldActionEventStates,
  actionEventsMap
} from "../screens/helpers/action-event-states";
import { isFieldsValid } from "./field-validation";

export const handleClickEvent = (field, screen, appData, context) => {
  const { action: screenAction, fields, footerFields } = screen;
  let actionField = field;

  if (field.type !== "callToActionButton" && field.type !== "settingsButton") {
    const newActionField = fields.find(
      field => field.type === "callToActionButton"
    );

    const newFooterActionField = footerFields.find(
      field => field.type === "callToActionButton"
    );

    actionField = newActionField || newFooterActionField;
  }

  const {
    name,
    text,
    title,
    action: fieldAction,
    __noValidation
  } = actionField || {};
  const { screenRef, settings } = appData;
  const action = fieldAction ?? screenAction;

  const handleButtonClickWrapper = () => {
    if (action?.type === "alert_url") {
      action.type = "url";
    }

    if (action?.type === "pop_screen") {
      return appData.handleBackButtonClick();
    }

    // The validation should be skipped in two cases:
    // 1. The action to be executed either has no 'needsValidation' property
    //    defined or the property is set to 'false'
    // 2. A special property called '__noValidation' is defined on the field
    //    and is set to 'true'
    const skipValidation =
      !(action?.needs_validation || action?.needsValidation) || __noValidation;
    const isDfd = appData.properLink;

    const onClickEventStates = getFieldActionEventStates(
      actionField,
      actionEventsMap.onClick
    );
    appData.updateStates(onClickEventStates, true);

    if (skipValidation || isFieldsValid(appData)) {
      if (onClickEventStates && !action?.value) {
        return;
      }

      if (name === "member_attachment_id") {
        appData.handleButtonClick(name, title.split("\n\n")[0], action);
      } else {
        appData.handleButtonClick(name, text, action);
      }
    } else {
      if (isDfd || action?.show_error_toast) {
        appData.screenValidation.setScreenValidity();
      }
      if (screenRef?.current?.scrollIntoView) {
        screenRef.current.focus();
        screenRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    }
  };

  return (() => {
    const dialogData = actionField?.action?.data;
    const meta = actionField?.action?.webLink
      ? {
          webLink: actionField?.action?.webLink
        }
      : {};
    return dialogData?.alert_title || dialogData?.alert_message
      ? context.showDialog({
          actions: [
            {
              label: settings.translations.cancel,
              className: "secondary",
              name: "close-dialog"
            },
            {
              label: dialogData?.button_title,
              onClick: handleButtonClickWrapper,
              name: actionField.name
            }
          ],
          content: {
            title: dialogData.alert_title,
            children: dialogData.alert_message,
            show_icon_warning: dialogData?.show_icon_warning
          },
          meta
        })
      : handleButtonClickWrapper();
  })();
};
